module.exports = __webpack_public_path__ + "static/media/s4.db9bd81e.jpg";